import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { FirebaseApi } from "src/app/core/classes/firebase-api";

@Injectable({
  providedIn: "root",
})
export class GeneralConfigService {
  private rndcContingencySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public rndcContingency$: Observable<boolean> = this.rndcContingencySubject.asObservable();
  private rndcContingencyUnsubscribe: () => void;
  private listeningRndcContingency: boolean = false;

  public startRndcContingencyListener(): void {
    if (this.listeningRndcContingency) return;
    const rndcState = FirebaseApi.root.firestore.collection("GlobalConfiguration").doc("RNDC");
    this.rndcContingencyUnsubscribe = rndcState.onSnapshot(
      (snapshot) => {
        const rndc = snapshot.data() as { contingencyActive: boolean };
        this.rndcContingencySubject.next(!!(rndc && rndc.contingencyActive));
      },
      () => this.rndcContingencySubject.next(false)

    );
    this.listeningRndcContingency = true;
  }

  public getRndcContingencyActive(): boolean {
    return this.rndcContingencySubject.getValue();
  }

  public stopRndcContingencyListener(): void {
    if (this.rndcContingencyUnsubscribe) {
      this.rndcContingencyUnsubscribe();
      this.rndcContingencyUnsubscribe = null;
    }
    this.listeningRndcContingency = false;
  }
}
